<template>
    <div class="modal modal-open" id="modal-add-link">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    class="btn btn-modal-close"
                    type="button"
                    @click="handleClose"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div v-if="!isEdit" class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="name">Document type*</label>
                                <treeselect
                                    v-model="new_data.type"
                                    :multiple="false"
                                    :clearOnSelect="true"
                                    :options="types"
                                />
                                <span class="error" v-if="errors.type"
                                    >Required</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">New type</label>
                                <input
                                    :disabled="new_data.type != 0"
                                    type="text"
                                    v-model="new_data.name"
                                    id="name"
                                />
                                <span
                                    class="error"
                                    v-if="new_data.type === 0 && errors.name"
                                    >Required</span
                                >
                            </div>
                        </div>

                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">URL*</label>
                                <input
                                    type="text"
                                    v-model="new_data.url"
                                    id="url"
                                />
                                <span class="error" v-if="errors.url"
                                    >Required</span
                                >
                            </div>
                        </div>
                        <div
                            v-if="new_data.type === 0"
                            class="col-xl-12 col-lg-12"
                        >
                            <div class="row jus-c--center">
                                <div class="col-xl-3 col-lg-4">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.common"
                                            id="common"
                                            name="common"
                                            class="common"
                                        />
                                        <label for="common"
                                            ><i class="icon icon-checkmark"></i
                                        ></label>
                                        For all agencies
                                    </div>
                                </div>
                                <div class="col-xl-3 col-lg-4">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="new_data.static"
                                            id="static"
                                            name="static"
                                            class="static"
                                        />
                                        <label for="static"
                                            ><i class="icon icon-checkmark"></i
                                        ></label>
                                        Static
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    {{ isEdit ? "Save" : "Add" }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addLink",
    props: {
        agency: {
            type: Object,
            required: false,
        },
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },
        isEdit: {
            type: Number,
            required: false,
        },
        editData: {
            type: Object,
            required: false,
        },
        onEdit: {
            type: Function,
            required: false,
        },
    },
    components: {
        Treeselect,
    },
    mounted() {
        this.getDocuments();

        if (this.isEdit) {
            this.new_data = JSON.parse(JSON.stringify(this.editData));
        }
    },
    data() {
        return {
            types: [
                {
                    id: 0,
                    label: "New document type",
                },
            ],
            new_data: {
                type: null,
                name: "",
                url: "",
                common: false,
                static: false,
            },
            errors: {
                type: false,
                url: false,
                name: false,
            },
        };
    },
    methods: {
        getDocuments() {
            axios
                .post("/agencies/documents/getDocuments", {
                    agencyId: this.agency.id,
                })
                .then((r) => {
                    this.types = [...this.types, ...r.data];
                });
        },
        handleClose(e) {
            this.onClose(e);
        },
        handleAdd(e) {
            this.errors = {
                url: false,
                type: false,
                name: false,
            };
            if (this.new_data.type === null) {
                this.errors.type = true;
            }

            if (!this.new_data.url) {
                this.errors.url = true;
            }

            if (this.new_data.type === 0 && !this.new_data.name) {
                this.errors.name = true;
            }

            if (this.errors.type || this.errors.url || this.errors.name) {
                return;
            }

            if (this.isEdit) {
                this.onEdit(this.isEdit, this.new_data);
                return;
            }
            this.onAdd(this.new_data);

            this.new_data = {
                type: null,
                name: "",
                url: "",
                common: false,
                static: false,
            };
        },
    },
};
</script>
